// extracted by mini-css-extract-plugin
export var container = "_50-0";
export var disabled = "_50-4";
export var fullWidth = "_50-3";
export var lined = "_50-1";
export var selected = "_50-5";
export var tab = "_50-2";